import { createTransform } from 'redux-persist'

/**
 * Keep credentials out of redux-persist, including tokens left by old builds.
 * Browser sessions now keep only a nonsecret marker in tokenStorage; the
 * actual Passport credential is an HttpOnly cookie. The in-memory auth shape
 * remains compatible with guards and the login flow.
 */
export const stripPersistedAuthToken = createTransform(
  (inboundState: Record<string, unknown> | undefined) => {
    if (!inboundState || typeof inboundState !== 'object') {
      return inboundState
    }
    const rest = { ...inboundState }
    delete rest.accessToken
    return rest
  },
  null,
  { whitelist: ['auth'] },
)
